import { delay, of } from "rxjs"

import {
  SUCCESS_GET_WATCH_LISTS_BY_ACCOUNT_ID_RESPONSE,
  SUCCESS_WATCH_LIST_RESPONSE,
} from "@/generated/TradingGateway"

import { mockWatchLists } from "../mockData/watchlistData"
import type {
  GetWatchListsByAccountIdResponse,
  IWatchListService,
  WatchListId,
  WatchListResponse,
} from "../WatchListService"

export const WatchListService: Pick<
  IWatchListService,
  "getWatchListsByAccountId" | "getWatchListById"
> = {
  getWatchListsByAccountId: () =>
    of<GetWatchListsByAccountIdResponse>({
      type: SUCCESS_GET_WATCH_LISTS_BY_ACCOUNT_ID_RESPONSE,
      payload: mockWatchLists,
    }).pipe(delay(100)),
  getWatchListById: (watchlistId: WatchListId) =>
    of<WatchListResponse>({
      type: SUCCESS_WATCH_LIST_RESPONSE,
      payload:
        mockWatchLists.find((wl) => wl.id === watchlistId.id) ??
        mockWatchLists[0],
    }).pipe(delay(100)),
}
